import { QuickActionsNav } from '@/components/quick-actions-nav';
import { MyProfileAvatar } from '@/components/my-profile-avatar';
import { Skeleton } from '@/components/ui/skeleton';
import { PlantProductionAndStorageOverviewAdvanced } from '@/features/plants/components/plant-overview/production-and-storage/advanced/plant-production-and-storage-overview-advanced.tsx';
import { PlantProductionAndStorageOverviewBasic } from '@/features/plants/components/plant-overview/production-and-storage/basic/plant-production-and-storage-overview-basic.tsx';
import { PlantStatusBanner } from '@/features/plants/components/plant-overview/production-and-storage/plant-status-banner.tsx';
import PlantUptimeStatusPopover from '@/features/plants/components/plant-monitoring/plant-uptime-status-popover.tsx';
import PlantBreadcrumb from '@/features/plants/components/shared/plant-breadcrumb.tsx';
import { useGetPlantQuery } from '@/features/plants/hooks/queries/[plantId]/use-get-plant.ts';
import { PlantMenuPopover } from '@/features/plants/components/plant-overview/plant-menu-popover.tsx';
import { usePlantsStore } from '@/services/store/use-plants-store.tsx';
import { useShallow } from 'zustand/react/shallow';

export const PlantOverviewAdvancedAndBasic = ({
  plantId,
}: {
  plantId: string | undefined;
}) => {
  const { data: plant, isLoading: isPlantLoading } = useGetPlantQuery({
    plantId: plantId,
  });

  const [pageView] = usePlantsStore(
    useShallow((state) => [state.pageView, state.setPageView])
  );

  const renderPageView = () => {
    if (pageView === 'basic')
      return <PlantProductionAndStorageOverviewBasic plantId={plantId} />;

    if (pageView === 'advanced')
      return <PlantProductionAndStorageOverviewAdvanced plantId={plantId} />;
  };

  return (
    <div className="overview w-full gap-2 overflow-auto px-4 pt-3 pb-8 sm:px-6">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          <PlantBreadcrumb plant={plant} />

          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>
        <div className="flex flex-col gap-4">
          {isPlantLoading ? (
            <Skeleton className="h-9 w-32" />
          ) : (
            <div className="flex w-full justify-between">
              <h2 className="text-2xl font-semibold">{plant?.basicDetails.name}</h2>
              <div className="flex items-center gap-2">
                <PlantUptimeStatusPopover />
                <PlantMenuPopover isLoading={isPlantLoading} />
              </div>
            </div>
          )}

          <PlantStatusBanner status={plant?.basicDetails.status} />

          {renderPageView()}
        </div>
      </div>
    </div>
  );
};

export default PlantOverviewAdvancedAndBasic;
